import { escapeHtml, isElement } from './html';
import { PositionableTextDocument } from '@src/lib/PositionableTextDocument';

const attrTypes = {};
attrTypes.schemaMarkAttrs = [
  'font-family',
  'font-weight',
  'font-style',
  'font-size',
  'color',
  'line-height',
  'variable'
];
attrTypes.schemaParagraphAttrs = ['text-align'];
attrTypes.schemaAttrs = attrTypes.schemaMarkAttrs.concat(
  attrTypes.schemaParagraphAttrs
);

export function markSpecGenerator(markName, transformers) {
  return {
    attrs: {
      [markName]: {},
      scale: {
        default: null
      }
    },
    toDOM: function (mark) {
      let styles = '';

      attrTypes.schemaMarkAttrs
        .filter(function (e) {
          return e !== 'line-height';
        })
        .forEach(function (attrName) {
          let styleName;
          let styleValue;

          if (attrName === markName && mark.attrs[markName]) {
            styleName = markName;
            styleValue = transformers.encode(mark.attrs[markName]);
          } else {
            styleName = attrName;
            styleValue = 'inherit';
          }

          styles += `${styleName}: ${styleValue}; `;
        });

      if (mark.attrs['line-height'] != null) {
        styles +=
          'line-height: ' +
          transformers.encode(mark.attrs['line-height']) +
          '; ';
      } else {
        styles += 'line-height: 0; ';
      }

      const markProps = {
        [markName]: transformers.encode(mark.attrs[markName]),
        style: styles
      };

      return ['m', markProps];
    },
    parseDOM: [
      {
        getAttrs: function (domNode) {
          const attrs = {};

          if (domNode instanceof Node && isElement(domNode)) {
            attrs[markName] = transformers.decode(
              domNode.getAttribute(markName)
            );

            return attrs;
          }
        },
        tag: 'm[' + markName + ']'
      }
    ]
  };
}

export function emptyDocument(
  alignment: string = 'left',
  marks: Record<string, string | number> = {}
) {
  const docString = `<p text-align="${alignment}" data-marks="${escapeHtml(
    JSON.stringify(marks)
  )}"></p>`;

  return PositionableTextDocument.fromPositionedDocument({
    ds: docString,
    pos: []
  });
}
